export interface File {
  fileName: string;
  url: string;
  key: string;
  created: Date;
}
